function token() {
  return localStorage.getItem("token") || sessionStorage.getItem("token") || "";
}
function authHeaders(json) {
  const h = {};
  const t = token();
  if (t) h.Authorization = `Bearer ${t}`;
  if (json) h["Content-Type"] = "application/json";
  return h;
}
const enc = encodeURIComponent;

export async function submitJob(items, opts) {
  const body = { items };
  if (opts && opts.label) body.label = opts.label;
  if (opts && opts.raw) body.raw = opts.raw; // {headers, rows, map} ≤2,000행 — 서버 보존(이력 다운로드)
  const r = await fetch("/api/onto/classify/jobs", {
    method: "POST",
    headers: authHeaders(true),
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(`잡 제출 실패: ${r.status}`);
  return r.json();
}
export async function startJobRun(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}/start`, {
    method: "POST",
    headers: authHeaders(false),
  });
  if (!r.ok) throw new Error(`분류 시작 실패: ${r.status}`);
  return r.json();
}
export async function getJobSource(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}/source`, {
    headers: authHeaders(false),
  });
  if (!r.ok) return null; // 원본 미보존/스코프 밖 — 호출부는 legacy 뷰 폴백
  const j = await r.json();
  return j && j.raw ? j.raw : null;
}
export async function listJobs(queryString) {
  const qs = queryString || "limit=50";
  const r = await fetch(`/api/onto/classify/jobs?${qs}`, {
    headers: authHeaders(false),
  });
  if (!r.ok) throw new Error(`잡 목록 실패: ${r.status}`);
  return r.json();
}
export async function deleteJob(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}`, {
    method: "DELETE",
    headers: authHeaders(false),
  });
  if (!r.ok) {
    let msg = `삭제 실패: ${r.status}`;
    try {
      const j = await r.json();
      if (j && j.error) msg = j.error;
    } catch (e) {
      /* 비-JSON */
    }
    throw new Error(msg);
  }
  return r.json();
}
export async function getJob(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}`, {
    headers: authHeaders(false),
  });
  if (!r.ok) throw new Error(`잡 조회 실패: ${r.status}`);
  return r.json();
}
export async function cancelJob(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}/cancel`, {
    method: "POST",
    headers: authHeaders(false),
  });
  return r.ok;
}
export async function retryFailed(jobId) {
  const r = await fetch(`/api/onto/classify/jobs/${enc(jobId)}/retry-failed`, {
    method: "POST",
    headers: authHeaders(false),
  });
  if (!r.ok) throw new Error(`재분류 실패: ${r.status}`);
  return r.json();
}
export async function getRatesSummary(hsks, opts) {
  if (!hsks || !hsks.length) return {};
  const ftaQs = opts && opts.fta ? "&fta=1" : "";
  const r = await fetch(
    `/api/onto/classify/rates-summary?hsks=${enc(hsks.join(","))}${ftaQs}`,
    { headers: authHeaders(false) },
  );
  if (!r.ok) return null; // 실패 — 호출부는 세율 3컬럼 공란 + 경고
  const j = await r.json().catch(() => null);
  return j && j.rates ? j.rates : null;
}

// hs4 단위 요건(수입공고/세관장확인 등) 조회 — 스텝2 요건 배지·스텝3 신고용 참고. 세션 캐시로 호출부가 배치.
export async function getReqFlags(hs4) {
  const r = await fetch(`/api/onto/req-customs?hs4=${enc(hs4)}`, {
    headers: authHeaders(false),
  });
  if (!r.ok) return null;
  const j = await r.json();
  return j && j.flags ? j.flags : {};
}

// 세번 상세(세율_grouped·요건 법령·원산지표시 등) — 인스펙터 요건 자세히 접이식이 지연 조회.
export async function getHskDetail(hsk) {
  const r = await fetch(`/api/onto/hsk-detail?hsk=${enc(hsk)}`, {
    headers: authHeaders(false),
  });
  if (!r.ok) return null;
  return r.json();
}

export async function confirmSeed(keyword, hsk, extra) {
  const r = await fetch("/api/onto/classify/confirm", {
    method: "POST",
    headers: authHeaders(true),
    body: JSON.stringify({ keyword, hsk, ...(extra || {}) }),
  });
  return r.ok;
}

export async function listExportLayouts() {
  const r = await fetch("/api/onto/classify/export-layouts", {
    headers: authHeaders(false),
  });
  if (!r.ok) return null; // 실패 — 호출부는 기본 레이아웃만
  const j = await r.json().catch(() => null);
  return j && Array.isArray(j.layouts) ? j.layouts : null;
}
export async function saveExportLayout(name, columns) {
  const r = await fetch("/api/onto/classify/export-layouts", {
    method: "POST",
    headers: authHeaders(true),
    body: JSON.stringify({ name, columns }),
  });
  if (!r.ok) {
    let msg = `레이아웃 저장 실패: ${r.status}`;
    try {
      const j = await r.json();
      if (j && j.error) msg = j.error;
    } catch (e) {
      /* 비-JSON */
    }
    throw new Error(msg);
  }
  return r.json();
}
export async function deleteExportLayout(id) {
  const r = await fetch(
    `/api/onto/classify/export-layouts/${enc(String(id))}`,
    {
      method: "DELETE",
      headers: authHeaders(false),
    },
  );
  return r.ok;
}
